export default "__VITE_ASSET__D2O7Nou___"